import TweenMax from 'gsap'

import {
  defaultKruin
} from './data'

import {
  altPipingCoords,
  defaultCoords,
  getCoords,
  getPolygonPoints
} from './dike'

import {
  getScenario,
  selectedScenario
} from './scenario'

import {
  filterByClassList,
  filterByIdList
} from './utils'

// Globals form cdnjs SnapSVG
const Snap = window.Snap
const mina = window.mina

export const defaultHiddenLayers = [
  '#pop--up--button--1',
  '#pop--up--button--2a',
  '#pop--up--button--2b',
  '#pop--up--button--3a',
  '#pop--up--button--3b',
  '#pop--up--button--4a',
  '#pop--up--button--4b',
  '#menu--bg',
  '#indicator--kruinhoogte',

  '#piping--variant-a',
  '#piping--variant-b',

  // stage__variates
  '.header--variaties',
  '.controls--variaties',
  '.stage--variaties',
  // stage__faalkans
  '.header--faalkans',
  '.controls--faalkans',
  '.stage--faalkans',
]

export const faalkansLayers = [
  '.header--faalkans',
  '.controls--faalkans',
  '.stage--faalkans',
]

export const variatiesLayers = [
  '.header--variaties',
  '.controls--variaties',
  '.stage--variaties',
]

export const layerMap = {
  voorland        : '#voorland',
  ruwheidDijk     : '#dijk--ruw',
  ruwheidVoorland : '#voorland--ruw',
  city            : '#stadje',
  // easter          : '#easteregg--shark',
  house           : '#huisje',
}

export const popupMap = {
  '1': 'Wanneer een voorland aanwezig is kan de kruinhoogte van de dijk omlaag.',
  '2a': 'Wanneer gebruik wordt gemaakt van een ruw talud, bijvoorbeeld door gebruik van basalt of een getrapt talud, dan kan de kruinhoogte van de dijk omlaag.',
  '2b': 'Wanneer gebruik wordt gemaakt van een ruw talud, bijvoorbeeld door gebruik van basalt of een getrapt talud, dan kan de kruinhoogte van de dijk omlaag.',
  '3a': 'Wanneer gekozen wordt voor een flauwere taludhelling, kan de kruinhoogte van de dijk omlaag.',
  '3b': 'Wanneer gekozen wordt voor een steilere taludhelling, zal de kruinhoogte van de dijk hoger moeten zijn.',
  '4a': 'Wanneer gekozen wordt voor een laag golfoverslagdebiet, bijvoorbeeld bij bebouwing op de dijk, zal de kruinhoogte van de dijk hoger moeten zijn.',
  '4b': 'Wanneer gekozen wordt voor een hoog golfoverslagdebiet, bijvoorbeeld als er geen bebouwing is in het achterland, kan de kruinhoogte van de dijk omlaag.',
}

export const state = {
  highwater: false,
  scenario: selectedScenario
}

// Kick everything off
defaultHiddenLayers.forEach(layer =>
  document.querySelectorAll(layer).forEach(node =>
    node.style.opacity = 0))

// SnapSVG instance
const SnapInstance = Snap(document.getElementById('stage'))
export const Dijk = SnapInstance.select('#dijk--default > polygon')
const Huis = SnapInstance.select('#huisje')
const Indicator = SnapInstance.select('#indicator--kruinhoogte')
const Kruin = Indicator.node.querySelector('text:first-of-type')
const popups = Array.from(document.querySelectorAll('.pop-up'))
const popupButtons = Array.from(document.querySelectorAll('.button-icon[id^="pop--up--button"]'))
const WaterThings = Array.from(document.querySelectorAll([
    '#water--bottom',
    '#water--front',
    '#bootje',
    '#water--toggle'
  ].join(',')))
  .map(node => SnapInstance.select(`#${node.id}`))

export function getActivePopups (scenario) {
  return scenario
    ? Object.keys(popupMap).filter(popupId =>
        scenario.stage.popups.indexOf(popupId) !== -1)
    : []
}

export function resetPopups (scenario) {
  const activePopupsIds = getActivePopups(scenario)
  const keepPopups = filterByClassList(popups, activePopupsIds)
  const keepPopupsButtons = filterByIdList(popupButtons, activePopupsIds)

  popups
    // .filter(popup => keepPopups.indexOf(popup) === -1)
    .filter(popup => popup.classList.contains('pop-up--active'))
    .forEach(popup => popup.classList.remove('pop-up--active'))

  popupButtons
    // .filter(popupButton => keepPopupsButtons.indexOf(popupButton) === -1)
    .filter(popupButton => popupButton.classList.contains('button-icon--active'))
    .forEach(popupButton => {
      popupButton.classList.remove('button-icon--active')
      TweenMax.to(popupButton, 0.3, {
        rotation: 0,
        transformOrigin: 'center'
      })
    })
}

export function togglePopup (popupButton, popup) {
  if (popupButton.classList.contains('button-icon--active')) {
    resetPopups({ stage: { popups: [popupButton.id.replace('pop--up--button--', '')] } })
    return
  }

  popupButton.classList.toggle('button-icon--active')
  popup.classList.toggle('pop-up--active')

  const buttonRect = popupButton.getBoundingClientRect()
  const popupRect = popup.getBoundingClientRect()

  popupButton.classList.contains('button-icon--active')
    ? TweenMax.to(popupButton, 0.3, {
      rotation: 45,
      transformOrigin: 'center'
    })
    : TweenMax.to(popupButton, 0.3, {
      rotation: 0,
      transformOrigin: 'center'
    })

  const popupX = buttonRect.left + (window.pageXOffset || window.scrollX) - ((popupRect.width - buttonRect.width) / 2)
  const popupY = buttonRect.top + (window.pageYOffset || window.scrollY) - (popupRect.height * 2)

  if (popupButton.classList.contains('button-icon--active')) {
    popup.style.left = `${parseInt(popupX)}px`
    popup.style.top = `${parseInt(popupY)}px`
  }
}

export function toggleWater(init) {
  if (!init)
    state.highwater = !state.highwater

  const scenario = getScenario()
  const transform = state.highwater
    ? `matrix(1,0,0,1,0,-145)`
    : `matrix(1,0,0,1,0,-85)`

  WaterThings.forEach(Thing => {
    Thing.animate({ transform }, 1000, mina.backout)
  })

  state.highwater
    ? TweenMax.to('.button-icon__direction', 0.3, {
        y: 2,
        rotation: 180,
        transformOrigin: 'center'
      })
    : TweenMax.to('.button-icon__direction', 0.3, {
        y: 0,
        rotation: 0,
        transformOrigin: 'center'
      })

  updateLayers(scenario)
}

export function transformWithCoord(coord, SnapNode, scenario, offset, useAltPipingCoord) {
  offset = Object.assign({ x: 0, y: -85 }, offset)
  let coords

  if (useAltPipingCoord)
    coords = altPipingCoords[useAltPipingCoord][coord]
  else
    coords = getCoords(coord, scenario.stage.factor, scenario.stage.talud)

  const x = coords[0] - defaultCoords[coord][0] + offset.x
  const y = coords[1] - defaultCoords[coord][1] + offset.y
  const transform = `matrix(1,0,0,1,${x},${y})`

  SnapNode.animate({ transform }, 1000, mina.easeinout)
}

export function updateDike (scenario) {
  const points = getPolygonPoints(scenario.stage.factor, scenario.stage.talud)

  Dijk.animate({ points }, 1000, mina.easeinout)

  transformWithCoord('d', Huis, scenario, { x: -145 })
}

export function updateIndicator (scenario, useAltPipingCoord) {
  const kruin = scenario.stage.kruin.toFixed(1)
  const kruinOffset = scenario.stage.kruin.toFixed(1) - defaultKruin.toFixed(1)
  const kruinOffsetStr = (kruinOffset > 0 ? '+ ' : '') + kruinOffset.toFixed(1)

  transformWithCoord('c', Indicator, scenario, {}, useAltPipingCoord)

  Kruin.textContent = `${kruin} meter (${kruinOffsetStr})`
}

export function updateLayers (scenario) {
  for (const layer in layerMap) {
    document.querySelector(layerMap[layer]).style.opacity = scenario.stage[layer]
  }

  if (state.highwater && scenario.stage.easter) {
    document.querySelector('#easteregg--shark').style.opacity = 1
  } else {
    document.querySelector('#easteregg--shark').style.opacity = 0
  }
}

export function updatePopupButtons (scenario) {
  const activePopupsIds = getActivePopups(scenario)
  const activePopupButtons = filterByIdList(popupButtons, activePopupsIds)

  popupButtons.forEach(popupButton => {
    popupButton.style.opacity = activePopupButtons.indexOf(popupButton) !== -1
      ? 1
      : 0
  })
}

export function updateScene () {
  const scenario = getScenario()

  resetPopups(scenario)
  updateDike(scenario)
  updateIndicator(scenario)
  updateLayers(scenario)
  updatePopupButtons(scenario)

  if (window.debug) {
    window.dispatchEvent(new CustomEvent('scene:update', scenario))
  }
}